<template>
  <div class="Map" />
</template>

<script>
import gmapsInit from "../gmaps.js"
import { getCoordinatesData } from "../databaseRequests"
import MarkerClusterer from "@google/markerclusterer"

var arrayLocal = []

for (var i = 0; i<4912; i++){
  arrayLocal.push({label: 'enterprise', position:{ lat: 41.5424365, lng: -8.436655 }})
}
for (var j = 0; j<14316; j++){
  arrayLocal.push({label: 'enterprise', position:{ lat: 41.1621376, lng: -8.6569731 }})
}
/*for (var j = 0; j<28; j++){
  arrayLocal.push({label: 'enterprise', position:{ lat: 40.2287388, lng:-8.4863144 }})
}*/

export default {
  name: "Map",
  async mounted(value) {
    try {
      const google = await gmapsInit()
      //var locations = await getCoordinatesData()
      var locations = arrayLocal

      const geocoder = new google.maps.Geocoder()
      const map = new google.maps.Map(this.$el)

      geocoder.geocode({ address: "Portugal" }, (results, status) => {
        if (status !== "OK" || !results[0]) {
          throw new Error(status)
        }
        map.setCenter({ lat: 39.75, lng: -8 })
        map.setZoom(7)
      })

      const markerClickHandler = marker => {
        map.setZoom(10)
        map.setCenter(marker.getPosition())
      }

      var markers = locations.map(x => new google.maps.Marker({ ...x, map }))

      var cluster = new MarkerClusterer(map, markers, {
        imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m"
      }).map(location => {
        const marker = new google.maps.Marker({ ...location, map })
        cluster.addListener("click", () => markerClickHandler(marker))
        return marker
      })
    } catch (error) {
      console.error(error)
    }
  }
}
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
}

.Map {
  width: 400px;
  height: 700px;
}
</style>
